import { render, staticRenderFns } from "./admin_dashboard.vue?vue&type=template&id=2b05ea81&scoped=true&"
import script from "./admin_dashboard.vue?vue&type=script&lang=js&"
export * from "./admin_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin_dashboard.vue?vue&type=style&index=0&id=2b05ea81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05ea81",
  null
  
)

export default component.exports